import { m } from 'motion/react';
import { containerVariants, itemVariants, viewPort } from 'utils/framer';
interface VideoClipProps extends React.ComponentPropsWithoutRef<'video'> {
  src: string;
  mobileSrc?: string;
  srcWebm?: string;
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
}
function VideoHero({
  src,
  srcWebm,
  mobileSrc,
  title,
  subTitle,
  children,
  className,
  ...props
}: VideoClipProps) {
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className="grid *:col-start-1 *:row-start-1"
    >
      <video
        autoPlay
        muted
        playsInline
        controls={props.controls || false}
        loop
        className={`w-full lg:max-h-[900px] object-cover ${className}`}
        {...props}
      >
        {srcWebm && <source src={`${srcWebm}#t=0.001`} type="video/webm" />}
        <source
          src={`${mobileSrc}#t=0.001`}
          type="video/mp4"
          media="(max-width:768px)"
        />
        <source src={`${src}#t=0.001`} type="video/mp4" />
      </video>
      {title ? (
        <m.div
          className="mt-9 lg:mt-0 lg:place-self-center text-center text-white px-4 z-10"
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={viewPort}
        >
          <m.h1
            className="text-[clamp(35px,_4vw,_72px)] mb-2"
            variants={itemVariants}
          >
            {title}
          </m.h1>
          {subTitle ? (
            <m.p
              variants={itemVariants}
              className="text-xl sm:text-2xl font-thin"
            >
              {subTitle}
            </m.p>
          ) : null}
        </m.div>
      ) : null}
      {children}
    </m.section>
  );
}

export default VideoHero;
